export default "__VITE_ASSET__CWcrFGK___"